/**
 * Used to validate quickpicks.
 * Caution: Year is not a 4 digit number, but a 2 digit number.
 */
export const isValidQuickPickDate = (year: number, month: number, day: number) => {
  const fullYear = 2000 + year
  const date = new Date(fullYear, month - 1, day)

  return date.getFullYear() === fullYear && date.getMonth() === month - 1 && date.getDate() === day
}
